import type { FC } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import PrivacyImage from './PrivacyImage'

const copy = {
  overline: `Privacy`,
  heading: `Protect sensitive user data`,
  description: `We are committed to protecting your data and the data of your users. Segment is designed to keep data secure while adhering to the most up-to-date data protection laws around the world. Importantly, all the data stored on the Segment platform is owned by you, and we will never sell it.`,
}

const link = {
  text: `Learn about Segment Privacy`,
  url: `/security/#commitment-to-data-privacy`,
}

const Customer: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper id="data-privacy">
      <StyledSectionBase variant="2Col" copyVariant="narrow" reverse={true}>
        <SectionCopy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h2" tag="h3">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
            <LinkWrapper size="medium" tag="a" href={getAbsoluteUrl(link.url, pageConfig)} iconEnd={ChevronRightIcon}>
              {link.text}
            </LinkWrapper>
          </CopyTextBase>
        </SectionCopy>

        <Section.Contents>
          <PrivacyImage />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: grid;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding-top: 45px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 0;
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const LinkWrapper = styled(ButtonText)`
  padding-top: 0;
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default Customer
